// React
import { useState } from "react"

// Components
import { DateInput } from "components"

// Form
import { Controller, useFormContext } from "react-hook-form"

// Third-Party Libraries
import moment from "moment"

export function PromisedDate(params: {
  disabled?: boolean
  name: string
}) {
  // Form
  const { control } = useFormContext()

  // State
  const [rawError, setRawError] = useState<string>("")

  return (
    <Controller
      control={control}
      name={params.name}
      render={({ field, fieldState }) => (
        <DateInput
          label="PROMISED DATE"
          disabled={params.disabled}
          error={rawError || fieldState.error?.message}
          selected={moment(field.value).toDate()}
          onChange={(date) => {
            if (!date) return
            setRawError("")
            field.onChange(moment(date).format("YYYY-MM-DD"))
          }}
          onChangeRaw={(e) => {
            const raw = (e.target as HTMLInputElement).value
            if (raw && !/^\d{2}\/\d{2}\/\d{4}$/.test(raw)) {
              setRawError("Format tanggal tidak valid (dd/MM/yyyy)")
            } else {
              setRawError("")
            }
          }}
        />
      )}
    />
  )
}